import { useQuery } from "@tanstack/react-query";
import client from "@/lib/api";

const TYPES = ["customers", "programmers", "grades", "ownership", "thicknesses", "machines"];

export function useMasters(includeInactive = false) {
  return useQuery({
    queryKey: ["masters", includeInactive],
    queryFn: async () => {
      const results = await Promise.all(
        TYPES.map((t) =>
          client.get(`/master-data/${t}`, { params: { includeInactive } }).then((r) => [t, r.data.data])
        )
      );
      return Object.fromEntries(results);
    },
    staleTime: 30000,
  });
}

export function useMasterList(type, includeInactive = false) {
  return useQuery({
    queryKey: ["master", type, includeInactive],
    queryFn: () =>
      client.get(`/master-data/${type}`, { params: { includeInactive } }).then((r) => r.data.data),
    staleTime: 15000,
  });
}
